module.exports = __webpack_public_path__ + "img/navigation-logo.c1032492.svg";